export default {
  containerized: {
    type: 'boolean',
    default: false,
  },
  title: {
    type: 'string',
    default: '',
  },
  titleTag: {
    type: 'string',
    default: 'h1',
  },
  variant: {
    type: 'string',
    default: 'title-1',
  },
  align: {
    type: 'string',
    default: 'left',
  },
  color: {
    type: 'string',
    default: 'color-black',
  },
  margin: {
    type: 'string',
    default: 'margin-none',
  },
  anchor: {
    type: 'string',
    default: '',
  },
  maxWitdh: {
    type: 'string',
    default: 'max-unset',
  },
};
